export enum AccessRight {
    reader = 0,
    writer = 1,
    author = 2,
    admin = 3
}



// WEBPACK FOOTER //
// ./src/app/enums/access.right.enum.ts